module.exports = __webpack_public_path__ + "img/icon_logo_green.5440ac25.svg";